export class Category {
  constructor(
    public id: string,
    public name: string,
    public companiesNumber: number,
    public createdAt: string,
    public nameTranslations: any
  ) { }
}